import type { ConversationResource } from '../types/resources/conversation'

export const ARCHIVED_DISABLED_REASON = 'archived'

const DEFAULT_ARCHIVED_MESSAGE = 'This conversation is archived.'

export const isArchivedConversation = (
  conversation: Pick<ConversationResource, 'disabledReason'>
) => conversation.disabledReason === ARCHIVED_DISABLED_REASON

export const archivedConversationMessage = (
  conversation: Pick<ConversationResource, 'disabledMessage'>
) => conversation.disabledMessage || DEFAULT_ARCHIVED_MESSAGE
